import { useToastContext } from "./toast-context";

interface UseToastReturn {
  showToast: (message: string, duration?: number) => string;
}

export const useCustomToast = (): UseToastReturn => {
  const { addToast } = useToastContext();

  return {
    showToast: (message: string, duration?: number): string =>
      addToast(message, "info", duration ?? 5000),
  };
};
